import { Navigate } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ADMIN_EMAIL = "kontakt@mateuszzalewski.pl";

export default function AdminOnly({ children }) {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <RefreshCw className="h-7 w-7 animate-spin text-[#ff4458]" />
      </div>
    );
  }

  const email = String(user?.email || "").trim().toLowerCase();
  const role = String(user?.role || "").trim().toLowerCase();

  if (email !== ADMIN_EMAIL || role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
